export default __webpack_public_path__ + "static/media/Visa_Logo.a458aef0.png";